<template>
  <div class="loader-container">
    <div class="spinner"></div>
    <p class="loader-text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    text: {
      type: String,
      default: 'Chargement...'
    }
  }
};
</script>

<style scoped>
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 14px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f0efed;
  border-top: 4px solid #3B6152;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-text {
  font-size: 15px;
  color: #777;
  margin: 0;
  font-family: 'Raleway', sans-serif;
}
</style>
